<template>
    <div class='serviceS'>
        <div class="serviceSS">
            <h2>服务范围</h2>
            <div class="cont">
                <div class="conTop">
                    <div class="conType" v-for="imte in list1">
                        <div class="image">
                            <img :src="imte.image" alt="">
                            <p>{{imte.title}}</p>
                        </div>
                    </div>
                </div>
                <div class="conTop">
                    <div class="conType" v-for="imte in list2">
                        <div class="image">
                            <img :src="imte.image" alt="">
                            <p>{{imte.title}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="conTxt">
                <p>彩虹律师高端律师服务</p>
                <p>作为新一代的互联网化的法律服务机构</p>
                <p>能为公司客户在日常经营、公司治理和商务活动提供广泛的高级法律服务</p>
                <el-button type="primary" @click="serviceP">查看详情</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "serviceS",
        data(){
            return{
                list1: [
                    {
                        image:require("../assets/img/专属资深律师.png"),
                        title:"专属资深律师"
                    },
                    {
                        image:require("../assets/img/公司业务法律咨询.png"),
                        title:"公司业务法律咨询"
                    },
                    {
                        image:require("../assets/img/公司合同文书.png"),
                        title:"公司合同文书"
                    },
                    {
                        image:require("../assets/img/金牌法务驻场.png"),
                        title:"金牌法务驻场"
                    }
                ],
                list2:[
                    {
                        image:require("../assets/img/投融资全程法律顾问.png"),
                        title:"投融资全程法律顾问"
                    },
                    {
                        image:require("../assets/img/签发律师函.png"),
                        title:"签发律师函"
                    },
                    {
                        image:require("../assets/img/律师上门.png"),
                        title:"律师上门"
                    },
                    {
                        image:require("../assets/img/诉讼仲裁服务8.5折.png"),
                        title:"诉讼仲裁服务8.5折"
                    }
                ]
            }
        },
        methods:{
            serviceP(){
                document.querySelector(".serviceP").scrollIntoView(true);
                // console.log("服务套餐")
            }
        }
    }
</script>

<style lang="less" scoped>
    .serviceS{
        padding-top:40px;
        width: 100%;
        height: 960px;
        background: rgb(248,248,248);
        background: url("../assets/img/banner10.png") no-repeat;
        background-size: cover;
        .serviceSS{
            padding-top: 40px;
            height: 600px;
            h2{
                font-size: 30px;
                color: rgb(43,43,43);
                text-align: center;
            }
            .cont{
                width: 1164px;
                margin: 0 auto;
                height: 100%;
                /*background: yellow;*/
                .conTop{
                    width: 100%;
                    height: 50%;
                    display: flex;
                    justify-content: space-around; /* 分布居中 */
                    align-items: center;     /* 垂直居中 */
                    .conType{
                        transition: 0.1s all;
                        height: 230px;
                        width: 240px;
                        background: white;
                        box-shadow: 0 5px 21px 0 rgba(3,20,58,0.14);
                        float: left;
                        display: flex;
                        justify-content: center; /* 水平居中 */
                        align-items: center;     /* 垂直居中 */
                        .image{
                            img{
                                width: 80px;
                                height: 80px;
                                display: block;
                                margin: 0 auto;
                            }
                            p{
                                padding-top: 20px;
                                font-size: 20px;
                                color: rgb(51,51,51);
                            }
                        }

                    }
                    .conType:hover{
                        transform: scale(1.1);
                    }
                }
            }
        }
        .conTxt{
            margin-top:40px;
            width: 100%;
            text-align: center;
            p{
                font-size: 22px;
                color: rgb(51,51,51);
                padding-bottom: 20px;
            }
            p:nth-child(1){
                color: rgb(50,150,250);
            }
            .el-button{
                width:150px;
                height:50px;
                border-radius:8px;
                color:white;
                background:rgb(50,150,250);
                font-size:14px;
                font-weight:550;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/serviceS.vue